module.exports = __webpack_public_path__ + "static/media/Mothboy.6465b9ea.png";